module.exports = __webpack_public_path__ + "img/BAU Seniors_Infographics_43.7476a828.png";